/**
 * 示例
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/iam/v1/{organizationId}',
  items: [
    // 列表
    { key: 'getConfigurationList', url: '/ConfigInfo/configurationList', method: 'POST' },
    // 获取用户渲染配置页面信息
    { key: 'getConfigPage', url: '/ConfigInfo/getConfigPage', method: 'POST' },

    // 删除用户配置
    { key: 'deleteConfig', url: '/ConfigInfo/deleteConfig', method: 'POST' },
    // 新增或修改用户配置
    { key: 'saveOrUpdateConfig', url: '/ConfigInfo/saveOrUpdateConfig', method: 'POST' },
    // 查看用户配置信息
    { key: 'viewConfig', url: '/ConfigInfo/viewConfig', method: 'POST' },
    // 操作日志
    { key: 'configurationLogInfo', url: '/ConfigInfo/configurationLogInfo', method: 'POST' },
    // 根据clientCode查询用户配置信息
    { key: 'queryUserConfiguration', url: '/ConfigInfo/queryUserConfiguration/{clientCode}', method: 'GET' },
    // 入场客户 列表
    { key: 'getOnboardingList', url: '/onboarding', method: 'POST' },
    // 入场客户 新增   post /v1/{organizationId}/onboarding/start
    { key: 'addOnboardingList', url: '/onboarding/start', method: 'POST' },
    // 入场客户 查看   get /v1/{organizationId}/onboarding/{id}
    { key: 'getOnboardingDetail', url: '/onboarding/{id}', method: 'GET' },
    // 入场客户 编辑   put /v1/{organizationId}/onboarding
    { key: 'putOnboardingList', url: '/onboarding', method: 'PUT' },
    // 入场客户 删除   delete /v1/{organizationId}/onboarding
    { key: 'delOnboardingList', url: '/onboarding?onboardingId={onboardingId}', method: 'DELETE' },
    // 入场客户 获取审核权限按钮   get /v1/{organizationId}/onboarding/task
    { key: 'taskOnboardingList', url: '/onboarding/task?onboardingId={onboardingId}', method: 'GET' },
    // 入场客户 查询当前流程完成进度   get /v1/{organizationId}/onboarding/progress
    { key: 'progressOnboardingList', url: '/onboarding/progress?onboardingId={onboardingId}', method: 'GET' },
    // 入场客户 审核按钮   post /v1/{organizationId}/onboarding/approve
    { key: 'approveOnboardingList', url: '/onboarding/approve', method: 'POST' },
    // 入场客户 全局右下角提示   get /v1/{organizationId}/onboarding/totalApprove
    { key: 'getOnboardingTip', url: '/onboarding/totalApprove', method: 'GET' },
    // 入场客户 跳用户新增数据回显   post /v1/{organizationId}/onboarding/query
    { key: 'getOnboardingUserAdd', url: '/onboarding/query', method: 'POST' },
    // 入场客户 查询是否可以编辑bpcode   get /v1/{organizationId}/onboarding/checkByBp
    { key: 'getOnboardingCheckByBp', url: '/onboarding/checkByBp?onboardingId={onboardingId}', method: 'GET' },
    // 入场客户 查询是否可以上传文件   get /v1/{organizationId}/onboarding/checkByChecklist
    { key: 'getOnboardingCheckByChecklist', url: '/onboarding/checkByChecklist?onboardingId={onboardingId}', method: 'GET' },
    // 入场客户 查询是否可以新增客户   get /v1/{organizationId}/onboarding/checkByCustomer
    { key: 'getOnboardingCheckByCustomer', url: '/onboarding/checkByCustomer?onboardingId={onboardingId}', method: 'GET' },
    
    // 客户面板 仪表盘统计信息   get /v1/{organizationId}/onboarding/statisticsDashboard
    { key: 'getOnboardingDashboard', url: '/onboarding/statisticsDashboard', method: 'GET' },
    // 客户面板 入场客户下拉框   get /v1/{organizationId}/onboarding/companyPull
    { key: 'getOnboardingCompanyPull', url: '/onboarding/companyPull', method: 'GET' },
    // 客户面板 根据客户查询信息   post /v1/{organizationId}/onboarding/customer-operational
    { key: 'getOnboardingQueryCOMT', url: '/onboarding/customer-operational', method: 'POST' },
    // 客户面板 手动完成sku   post /v1/{organizationId}/onboarding/manuallySku
    { key: 'getOnboardingManuallySku', url: '/onboarding/manuallySku', method: 'POST' },
    // 客户面板 手动完成store   post /v1/{organizationId}/onboarding/manuallyStore
    { key: 'getOnboardingManuallyStore', url: '/onboarding/manuallyStore', method: 'POST' },

    // 成本支出统计 列表   post /v1/{organizationId}/cost/list
    { key: 'getCostExpenditureList', url: '/cost/list', method: 'POST' },
    // 成本支出统计 费用项下拉框  get /v1/{organizationId}/cost/itemPull
    { key: 'getCostExpenditureItemPull', url: '/cost/itemPull', method: 'GET' },
    // 成本支出统计 类别下拉框  get /v1/{organizationId}/cost/categoryPull
    { key: 'getCostExpenditureCategoryPull', url: '/cost/categoryPull', method: 'GET' },
    // 成本支出统计 新增   post /v1/{organizationId}/cost/add
    { key: 'addCostExpenditureList', url: '/cost/add', method: 'POST' },
    // 成本支出统计 删除   delete /v1/{organizationId}/cost/delete
    { key: 'delCostExpenditureList', url: '/cost/delete?costId={costId}', method: 'DELETE' },
    // 成本支出统计 修改   put /v1/{organizationId}/cost/update
    { key: 'editCostExpenditureList', url: '/cost/update', method: 'PUT' },
    // 成本支出统计 查看   get /v1/{organizationId}/cost/{costId}
    // { key: 'viewCostExpenditureList', url: '/cost/{costId}', method: 'GET' },

    // 仓库人工管理 列表   post /v1/{organizationId}/staff/list
    { key: 'getWarehouseStaffList', url: '/staff/list', method: 'POST' },
    // 仓库人工管理 人员下拉   get /v1/{organizationId}/staff/namePull
    { key: 'getWarehouseStaffNamePull', url: '/staff/namePull', method: 'GET' },
    // 仓库人工管理 部门下拉   get /v1/{organizationId}/staff/deptPull
    { key: 'getWarehouseStaffDeptPull', url: '/staff/deptPull', method: 'GET' },
    // 仓库人工管理 部门下拉(权限查看)   get /v1/{organizationId}/staff/queryByDept
    { key: 'getWarehouseStaffDeptPullKEY', url: '/staff/queryByDept', method: 'GET' },
    // 仓库人工管理 新增   post /v1/{organizationId}/staff/add
    { key: 'addWarehouseStaffList', url: '/staff/add', method: 'POST' },
    // 仓库人工管理 删除   delete /v1/{organizationId}/staff/delete
    { key: 'delWarehouseStaffList', url: '/staff/delete?staffId={staffId}', method: 'DELETE' },
    // 仓库人工管理 修改   put /v1/{organizationId}/staff/update
    { key: 'editWarehouseStaffList', url: '/staff/update', method: 'PUT' },
    // 仓库人工管理 列表   get /v1/{organizationId}/staff/{staffId}
    // { key: 'viewWarehouseStaffList', url: '/staff/{staffId}', method: 'GET' },

    // 仓库部门管理 主管下拉   get /v1/{organizationId}/dept/userList
    { key: 'getWarehouseDeptUserList', url: '/dept/userList', method: 'GET' },
    // 仓库部门管理 树状菜单   get /v1/{organizationId}/dept/menu/tree
    { key: 'getWarehouseDeptTree', url: '/dept/menu/tree', method: 'GET' },
    // 仓库部门管理 树状新增   post /v1/{organizationId}/dept/menu/add
    { key: 'addWarehouseDeptList', url: '/dept/menu/add', method: 'POST' },
    // 仓库部门管理 树状删除   delete /v1/{organizationId}/dept/menu/del
    { key: 'delWarehouseDeptMenuList', url: '/dept/menu/del?id={id}', method: 'DELETE' },
    // 仓库部门管理 部门列表   post /v1/{organizationId}/dept/list
    { key: 'getWarehouseDeptList', url: '/dept/list', method: 'POST' },
    // 仓库部门管理 列表修改   put /v1/{organizationId}/dept/update
    { key: 'editWarehouseDeptList', url: '/dept/update', method: 'PUT' },
    // 仓库部门管理 列表删除   delete /v1/{organizationId}/dept/delete
    { key: 'delWarehouseDeptList', url: '/dept/delete?id={id}', method: 'DELETE' },

    // 用工管理 列表   post /v1/{organizationId}/workforce/week
    { key: 'getWorkforceList', url: '/workforce/week', method: 'POST' },
    // 用工管理 工时导出   get /v1/{organizationId}/workforce/timesheet/export
    { key: 'exportWorkFile', url: '/workforce/timesheet/export', method: 'GET', rType: 2 },
    // 用工管理 工时导出 双周下拉框   get /v1/{organizationId}/workforce/timesheet/period/fortnightly
    { key: 'exportFortnightly', url: '/workforce/timesheet/period/fortnightly', method: 'GET' },
    // 用工管理 工时导出 单周下拉框   get /v1/{organizationId}/workforce/timesheet/period/weekly
    { key: 'exportWeekly', url: '/workforce/timesheet/period/weekly', method: 'GET' },
    // 用工管理 工时导出 劳务派遣下拉框   get /v1/{organizationId}/workforce/timesheet/period/labour
    { key: 'exportLabour', url: '/workforce/timesheet/period/labour', method: 'GET' },
    // 用工管理 员工请假导入   post /v1/{organizationId}/workforce/staffLeave/import
    { key: 'importWorkforceStaffLeave', url: '/workforce/staffLeave/import', method: 'POST', type: 'form', cType: 2, timeout: 10 * 60 * 1000 },
    // 用工管理 员工请假记录
    { key: 'getWorkforceStaffLeaveList', url: '/workforce/staffLeave/list', method: 'GET' },
    // 用工管理 plan人员下拉列表   get /v1/{organizationId}/workforce/staffPull
    { key: 'getWorkforceStaffList', url: '/workforce/staffPull?department={department}', method: 'GET' },
    // 用工管理 plan添加计划用工   post /v1/{organizationId}/workforce/add/plan
    { key: 'addWorkforceStaffPlan', url: '/workforce/add/plan', method: 'POST' },
    // 用工管理 plan添加计划用工(回显)   get /v1/{organizationId}/workforce/plan/list
    { key: 'getWorkforceStaffPlanData', url: '/workforce/plan/list?department={department}&workDate={workDate}', method: 'GET' },
    // 用工管理 Actual添加实际用工   post /v1/{organizationId}/workforce/add/actual
    { key: 'addWorkforceStaffActual', url: '/workforce/add/actual', method: 'POST' },
    // 用工管理 Actual添加实际用工(回显)   get /v1/{organizationId}/workforce/actual/list
    { key: 'getWorkforceStaffActual', url: '/workforce/actual/list?department={department}&workDate={workDate}', method: 'GET' },
    { key: 'getWorkforceReviewActual', url: '/workforce/actual/list?workDate={workDate}', method: 'GET' },
    // 用工管理 overtime添加加班员工   post /v1/{organizationId}/workforce/add/overtime
    { key: 'addWorkforceStaffOvertime', url: '/workforce/add/overtime', method: 'POST' },
    // 用工管理 overtime添加加班员工(回显)   get /v1/{organizationId}/workforce/overtime/list
    { key: 'getWorkforceStaffOvertime', url: '/workforce/overtime/list?department={department}&workDate={workDate}', method: 'GET' },
    { key: 'getWorkforceReviewOvertime', url: '/workforce/overtime/list?workDate={workDate}', method: 'GET' },
    // 用工管理 plan添加计划用工(数据清空)   post /v1/{organizationId}/workforce/discardPlan
    { key: 'discardWorkforcePlan', url: '/workforce/discardPlan', method: 'POST' },
    // 用工管理 overtime添加加班员工(数据清空)   post /v1/{organizationId}/workforce/discardActual
    { key: 'discardWorkforceActual', url: '/workforce/discardActual', method: 'POST' },

    // 成本项 分页列表   post /v1/{organizationId}/item/list
    { key: 'getBillingCostItemList', url: '/item/list', method: 'POST' },
    // 成本项 树形列表   get /v1/{organizationId}/item/menu/tree
    { key: 'getBillingCostItemTree', url: '/item/menu/tree', method: 'GET' },
    // 成本项 树形列表新增   post /v1/{organizationId}/item/menu/add
    { key: 'addBillingCostItemList', url: '/item/menu/add', method: 'POST' },
    // 成本项 分页列表编辑   put /v1/{organizationId}/item/update
    { key: 'editBillingCostItemList', url: '/item/update', method: 'PUT' },
    // 成本项 删除   delete /v1/{organizationId}/item/delete
    { key: 'delBillingCostItemList', url: '/item/delete?id={id}', method: 'DELETE' },

    // 判断是否需要给当前用户发提示邮件  get /v1/{organizationId}/mass/getNeedConfirmEmailList
    { key: 'getNeedConfirmEmailList', url: '/mass/getNeedConfirmEmailList', method: 'GET', loadingHide: true },
    // 用户确认提示邮件  post /v1/{organizationId}/mass/confirmEmail/{emailId}
    { key: 'userConfirmEmail', url: '/mass/confirmEmail/{emailId}', method: 'POST' },
  ],
};

export default {
  ...generate(config),
};
